// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.streams-drawer-list-item {
  border: 1px solid #e9eaec;
  overflow-y: hidden;
  height: 194px;
}
.streams-drawer-list-item .list-item-image-wrapper {
  align-items: center;
  background-color: #f5f6f6;
  justify-content: center;
  height: 192px;
  width: 192px;
}
.streams-drawer-list-item .location-link {
  color: #007c92;
  white-space: nowrap;
}
.streams-drawer-list-item .description-container {
  overflow-y: scroll;
  overflow-x: hidden;
}
`, "",{"version":3,"sources":["webpack://./app/streams-drawer/streams-drawer-content/streams-drawer-list-item/streams-drawer-list-item.less"],"names":[],"mappings":"AAMA;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;AALF;AAEA;EAMI,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;AALJ;AALA;EAcI,cAAA;EACA,mBAAA;AANJ;AATA;EAmBI,kBAAA;EACA,kBAAA;AAPJ","sourcesContent":["@import (reference) '../../../../css/unison';\n\n// TODO: Make this an official Unison size unit\n@cu-very-small-measure: 192px;\n@border-width: 1px;\n\n.streams-drawer-list-item {\n  border: @border-width solid @cu-gray-1;\n  overflow-y: hidden;\n  height: @cu-very-small-measure + 2 * @border-width;\n\n  .list-item-image-wrapper {\n    align-items: center;\n    background-color: @cu-gray-0;\n    justify-content: center;\n    height: @cu-very-small-measure;\n    width: @cu-very-small-measure;\n  }\n\n  .location-link {\n    color: @cu-color-primary;\n    white-space: nowrap;\n  }\n\n  .description-container {\n    overflow-y: scroll;\n    overflow-x: hidden;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
